import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { MailTemplateQuery, MailTemplateQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(MailTemplateQuery)
@Wrapper(MailTemplateQueryHandlerBase)
export class MailTemplateQueryHandler {
    public constructor(
        http: Http
    ) { }
}
